<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" id="already-registered-modal">
          <div class="modal-header">
            <div class="title-header">
              Your My24 Account was successfully created.
            </div>
            <a class="btn btn-link pull-right close-modal" @click="$emit('closeModal')"><i class="fa fa-close"></i></a>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="text-24">
                <p>
                  <b>Success!</b> Your My24 Account was successfully created.
                </p>
              </div>
            </div>
            <div class="row">
              <div class="alert alert-warning" role="alert">
                Your Fit:Perks® Account was not successfully created because the email address is already in use and cannot be used at this time.
                Please contact us <a v-bind:href="contactUsURL" v-on:click="redirectToContactUs()" class="here-link">here</a> or email us at
                <a href="mailto:CustomerServiceWT@24hourfit.com" class="here-link">CustomerServiceWT@24hourfit.com</a>.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import cfg from '../services/configuration/PropertiesConfiguration'

  export default {
    name: 'already-registered-modal',
    mounted () {
      document.addEventListener('keyup', this.listener)
      this.contactUsURL = cfg.contactUsUrl
    },
    beforeDestroy () {
      document.removeEventListener('keyup', this.listener)
    },
    data () {
      return {
        fitPerksURL: 'https://www.24hourfitness.com/fitperks/',
        contactUsURL: '',
        listener: evt => {
          if (evt.keyCode === 27) {
            this.$emit('closeModal')
          }
        }
      }
    },
    methods: {
      redirectToContactUs () {
        window.location.href = cfg.contactUsUrl
      }
    }
  }
</script>
<style lang="scss" scoped="true">
  @import "../../node_modules/bootstrap-sass/assets/stylesheets/bootstrap/_variables.scss";
  @import '~my-account-common-css/stylesheets/materialized.scss';

    #already-registered-modal {

      border: 1px solid $md-brand-green;
      max-width: 800px;

      .modal-header {

        background-color: $md-brand-green;
        color: white;
        font-weight: bold;

        .close-modal {

          &:hover, &:focus, &:active {

            color: white;

          }

        }

      }

      .modal-body {

        margin: 0 0 10px 0;
        padding: 0 25px 15px 25px;
        max-height: 500px;

        .text-24 {

          margin: 20px auto;
          font-size: 1.2em;

        }

        .checkbox-link {

          color: #0067B1;
          text-decoration: underline;
          font-weight: bold;
          font-size: 1em;

        }

        .here-link {
          color: blue;
          font-weight: bold;
          text-decoration: underline;
        }
      }

    }

  /* Small devices (phones under 768px) */
  @media (max-width: $screen-sm-min) {
    .modal-mask {
      .modal-wrapper .modal-container {
        position: relative;
        top: 60px;
        width: 90%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AlreadyRegisteredModal.vue